import { Loader2 } from "lucide-react";
import { money } from "@/lib/api";
import { fmtDateTime } from "@/lib/dateFormat";

const PAY_METHOD_LABEL = { bank_transfer: "Bank transfer", card: "Card", cash: "Cash", direct_debit: "Direct debit", cheque: "Cheque", other: "Other" };

// logs: null = loading, [] = none, [...] = rows. Each row: { amount, method, paid_at|created_at, recorded_by_name|created_by_name, is_refund, voided }
export function PaymentLog({ logs, title = "Payment log" }) {
  const rows = (logs || []).filter((p) => !p.voided);
  return (
    <div data-testid="payment-log">
      <p className="mb-1.5 mt-1 text-[11px] font-bold uppercase tracking-widest text-muted-foreground">{title}</p>
      {logs === null ? (
        <div className="flex justify-center py-3"><Loader2 className="h-4 w-4 animate-spin text-brand" /></div>
      ) : rows.length === 0 ? (
        <p className="rounded-lg border border-dashed border-border py-3 text-center text-xs text-muted-foreground">No payments recorded yet.</p>
      ) : (
        <div className="max-h-40 divide-y divide-border overflow-y-auto rounded-lg border border-border">
          {rows.map((p, i) => (
            <div key={p.id || i} data-testid={`payment-log-row-${i}`} className="px-3 py-2">
              <p className="text-sm font-bold text-midnight">{p.is_refund ? "−" : ""}{money(p.amount)} <span className="text-xs font-normal text-muted-foreground">· {PAY_METHOD_LABEL[p.method] || p.method || "—"}</span></p>
              <p className="truncate text-[11px] text-muted-foreground">{fmtDateTime(p.paid_at || p.created_at)}{(p.recorded_by_name || p.created_by_name) ? ` · ${p.recorded_by_name || p.created_by_name}` : ""}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
